module.exports = __webpack_public_path__ + "img/docs-icon.80a388bf.svg";